module.exports = __webpack_public_path__ + "img/list-item.01539b49.png";